module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_vm._t("tools")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content form-horizontal"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-422fdc14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lte/Ibox.vue
// module id = 448
// module chunks = 1